// Author YuJiaBei
// Date 2021-06-21 17:50:20

class EmOpcUaPublishRecordEoupr {
constructor({
        id = null,
        nodeId = '',
        value = '',
        timestamps = '',
        serverTime = '',
        remark = ''}
= {}) {
    this.id = id;
    this.nodeId = nodeId;
    this.value = value;
    this.timestamps = timestamps;
    this.serverTime = serverTime;
    this.remark = remark;
}
}

function newEntity() {
return new EmOpcUaPublishRecordEoupr();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.em.base.opcClient.emOpcUaPublishRecordEoupr.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'nodeId',
        label: 'label.em.base.opcClient.emOpcUaPublishRecordEoupr.grid.nodeId',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'value',
        label: 'label.em.base.opcClient.emOpcUaPublishRecordEoupr.grid.value',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'timestamps',
        label: 'label.em.base.opcClient.emOpcUaPublishRecordEoupr.grid.timestamps',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'serverTime',
        label: 'label.em.base.opcClient.emOpcUaPublishRecordEoupr.grid.serverTime',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.em.base.opcClient.emOpcUaPublishRecordEoupr.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    idFilter : "",
    idListFilter : "",
    nodeIdFilter : "",
    valueFilter : "",
    timestampsFilter : "",
    serverTimeRteFilter : "",
    serverTimeLteFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'nodeIdFilter',
        label: 'label.em.base.opcClient.emOpcUaPublishRecordEoupr.filter.nodeId',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'valueFilter',
        label: 'label.em.base.opcClient.emOpcUaPublishRecordEoupr.filter.value',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'timestampsFilter',
        label: 'label.em.base.opcClient.emOpcUaPublishRecordEoupr.filter.timestamps',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'serverTimeRteFilter',
        label: 'label.em.base.opcClient.emOpcUaPublishRecordEoupr.filter.serverTimeRte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'serverTimeLteFilter',
        label: 'label.em.base.opcClient.emOpcUaPublishRecordEoupr.filter.serverTimeLte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'nodeId',
        label: 'label.em.base.opcClient.emOpcUaPublishRecordEoupr.entity.nodeId',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'value',
        label: 'label.em.base.opcClient.emOpcUaPublishRecordEoupr.entity.value',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'timestamps',
        label: 'label.em.base.opcClient.emOpcUaPublishRecordEoupr.entity.timestamps',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'serverTime',
        label: 'label.em.base.opcClient.emOpcUaPublishRecordEoupr.entity.serverTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'remark',
        label: 'label.em.base.opcClient.emOpcUaPublishRecordEoupr.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {EmOpcUaPublishRecordEoupr, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
